import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  background: linear-gradient(180deg, #0a1321 0%, #0f231f 100%);
  padding-bottom: 100px;
`;

export const HeroSection = styled.section`
  max-width: 1728px;
  margin: 0 auto;
  padding: 134px 144px 0;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 40px;
`;

export const HeroContent = styled.div`
  flex: 1;
  max-width: 798px;
  display: flex;
  flex-direction: column;
`;

export const HeroTitle = styled.h1`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 24px;
  font-family: 'Aggro', sans-serif;
  font-size: 48px;
  font-weight: 700;
  line-height: 1.5;
  letter-spacing: -0.96px;
  overflow: visible;
  padding-bottom: 4px;

  filter: drop-shadow(2px 0 0 #000000) drop-shadow(-2px 0 0 #000000)
    drop-shadow(0 2px 0 #000000) drop-shadow(0 -2px 0 #000000)
    drop-shadow(2px 2px 0 #000000) drop-shadow(-2px 2px 0 #000000)
    drop-shadow(2px -2px 0 #000000) drop-shadow(-2px -2px 0 #000000);
`;

export const TitleCopy = styled.span`
  background: linear-gradient(90deg, #07d993 0%, #ffcc0d 50%, #ff8a00 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
`;

export const TitleTrading = styled.span`
  color: #ffffff;
`;

export const HeroDescription = styled.p`
  font-family: 'NanumSquareRound', sans-serif;
  font-size: 20px;
  font-weight: 400;
  color: #ffffff;
  line-height: 28px;
  letter-spacing: -0.4px;
  margin-bottom: 42px;
`;

export const HeroButtons = styled.div`
  display: flex;
  gap: 24px;
`;

export const TransferButton = styled.button`
  padding: 20px 40px;
  background: #07d993;
  border: none;
  border-radius: 20px;
  color: #0d1117;
  font-family: 'NanumSquareRound', sans-serif;
  font-size: 24px;
  font-weight: 700;
  letter-spacing: -0.48px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: #06c885;
  }
`;

export const BecomeLeaderButton = styled.button`
  padding: 20px 40px;
  background: transparent;
  border: 1px solid #07d993;
  border-radius: 20px;
  color: #07d993;
  font-family: 'NanumSquareRound', sans-serif;
  font-size: 24px;
  font-weight: 700;
  letter-spacing: -0.48px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: rgba(7, 217, 147, 0.1);
  }
`;

export const HeroImage = styled.div`
  width: 260px;
  height: 253px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const CharacterImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: 50% 50%;
`;

export const TabsSection = styled.section`
  max-width: 1728px;
  margin: 0 auto;
  padding: 0 144px;
  margin-top: 109px;
`;

export const TabsContainer = styled.div`
  display: flex;
  gap: 24px;
  justify-content: center;
`;

export const Tab = styled.button<{ $isActive: boolean }>`
  padding: 0 24px;
  height: 52px;
  background: transparent;
  border: ${(props) => (props.$isActive ? '1px solid #07d993' : 'none')};
  border-radius: 12px;
  color: ${(props) => (props.$isActive ? '#ffffff' : '#777986')};
  font-family: 'NanumSquareRound', sans-serif;
  font-size: 20px;
  font-weight: 400;
  letter-spacing: -0.4px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    color: #ffffff;
  }
`;

export const TradersSectionWrapper = styled.div`
  widthn: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const TradersSection = styled.section`
  width: 100%;
  max-width: 1440px;

  margin-top: 32px;
`;

export const TradersHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 46px;
  width: 100%;
  max-width: 1440px;
`;

export const TradersTitle = styled.h2`
  font-family: 'Aggro', sans-serif;
  font-size: 28px;
  font-weight: 500;
  color: #ffffff;
  letter-spacing: -0.56px;
  flex-shrink: 0;
`;

export const SearchContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  width: 188px;
  height: 46px;
  padding: 4px 12px;
  background: #0d1117;
  border-radius: 12px;
`;

export const SearchIcon = styled.img`
  width: 20px;
  height: 20px;
  flex-shrink: 0;
`;

export const SearchInput = styled.input`
  flex: 1;
  background: transparent;
  border: none;
  color: #b3b5bd;
  font-family: 'NanumSquareRound', sans-serif;
  font-size: 12px;
  font-weight: 400;
  letter-spacing: -0.24px;
  outline: none;

  &::placeholder {
    color: #b3b5bd;
  }
`;

export const LoadingContainer = styled.div`
  text-align: center;
  padding: 60px 0;
  color: #ffffff;
`;

export const TradersGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  column-gap: 20px;
  row-gap: 32px;
  width: 100%;
`;

const getRankCardStyles = (rank: number) => {
  switch (rank) {
    case 1:
      return {
        background: '#1f2520',
        border: '#ffd36a',
      };
    case 2:
      return {
        background: '#1b272f',
        border: '#e6e9ef',
      };
    case 3:
      return {
        background: '#1f2428',
        border: '#e0a370',
      };
    default:
      return null;
  }
};

export const TraderCard = styled.div<{
  $isMyPortfolio?: boolean;
  $rank?: number;
}>`
  box-sizing: border-box;
  min-width: 0;
  overflow: hidden;
  padding: 36px 30px;
  background: ${(props) => {
    if (props.$isMyPortfolio) {
      return 'linear-gradient(135deg, rgba(255, 204, 13, 0.15) 0%, rgba(255, 138, 0, 0.08) 100%)';
    }
    const rankStyles = props.$rank ? getRankCardStyles(props.$rank) : null;
    return rankStyles ? rankStyles.background : 'rgba(0, 110, 73, 0.08)';
  }};
  border-radius: 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  border: ${(props) => {
    if (props.$isMyPortfolio) {
      return '2px solid #ffcc0d';
    }
    const rankStyles = props.$rank ? getRankCardStyles(props.$rank) : null;
    return rankStyles
      ? `1px solid ${rankStyles.border}`
      : '1px solid transparent';
  }};
  position: relative;

  &:hover {
    border: ${(props) => {
      if (props.$isMyPortfolio) {
        return '2px solid #ffcc0d';
      }
      const rankStyles = props.$rank ? getRankCardStyles(props.$rank) : null;
      return rankStyles
        ? `1px solid ${rankStyles.border}`
        : '1px solid #07d993';
    }};
  }
`;

export const MyPortfolioBadge = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
  padding: 4px 8px;
  background: linear-gradient(90deg, #ffcc0d 0%, #ff8a00 100%);
  border-radius: 12px;
  font-family: 'NanumSquareRound', sans-serif;
  font-size: 12px;
  font-weight: 700;
  color: #0d1117;
  letter-spacing: -0.24px;
  z-index: 1;
`;

export const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  min-width: 0;
`;

export const TraderInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 18px;
  flex: 1;
  min-width: 0;
`;

export const AvatarWrapper = styled.div`
  position: relative;
  width: 64px;
  height: 64px;
  background: #ffffff;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const RankBadge = styled.div<{ $rank: number }>`
  position: absolute;
  left: 44px;
  top: 44px;
  width: 24px;
  height: 24px;
  background: #07d993;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const RankNumber = styled.span`
  font-family: 'NanumSquareRound', sans-serif;
  font-size: 16px;
  font-weight: 800;
  color: #ffffff;
  letter-spacing: -0.32px;
`;

export const CrownIcon = styled.img`
  width: 92px;
  height: auto;
  flex-shrink: 0;
  object-fit: contain;
`;

export const TraderDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
  min-width: 0;
`;

export const TraderName = styled.div`
  font-family: 'NanumSquareRound', sans-serif;
  font-size: 24px;
  font-weight: 400;
  color: #ffffff;
  letter-spacing: -0.48px;
  word-wrap: break-word;
  overflow-wrap: break-word;
`;

export const CopyTradesCount = styled.div`
  font-family: 'NanumSquareRound', sans-serif;
  font-size: 18px;
  font-weight: 400;
  color: #9496a1;
  letter-spacing: -0.36px;
`;

export const AvatarImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 999px;
`;

export const AvatarFallback = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #07d993 0%, #05a070 100%);
  font-family: 'NanumSquareRound', sans-serif;
  font-size: 28px;
  font-weight: 700;
  color: #ffffff;

  &.hidden {
    display: none;
  }
`;

export const CardStats = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const ROISection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const ROILabel = styled.div`
  font-family: 'NanumSquareRound', sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #b3b5bd;
  letter-spacing: -0.84px;
`;

export const ROIValue = styled.div<{ $isNegative?: boolean }>`
  font-family: 'NanumSquareRound', sans-serif;
  font-size: 28px;
  font-weight: 700;
  color: ${({ $isNegative }) => ($isNegative ? '#ef4444' : '#07d962')};
  letter-spacing: -1.68px;
`;

export const ChartWrapper = styled.div`
  width: 136.933px;
  height: 52px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  .recharts-wrapper {
    width: 100% !important;
    height: 100% !important;
  }

  .recharts-surface {
    width: 100% !important;
    height: 100% !important;
  }
`;

export const CardMetrics = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

export const MetricItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 180px;

  &:last-child {
    flex: 1;
  }
`;

export const MetricLabel = styled.div`
  font-family: 'NanumSquareRound', sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #b3b5bd;
  letter-spacing: -0.84px;
`;

export const MetricValue = styled.div`
  font-family: 'NanumSquareRound', sans-serif;
  font-size: 16px;
  font-weight: 700;
  color: #ffffff;
  letter-spacing: -0.96px;
`;

export const CopyTradeButton = styled.button<{
  $isFollowing: boolean;
  $isMyPortfolio: boolean;
}>`
  width: 100%;
  padding: 20px 0;
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  color: #ffffff;
  font-family: 'NanumSquareRound', sans-serif;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: -0.28px;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;

  &:hover:not(:disabled) {
    background: rgba(255, 255, 255, 0.05);
    border-color: rgba(255, 255, 255, 0.3);
  }

  &:disabled {
    opacity: 0.5;
  }
`;

// Following Tab Styles
export const FollowingSection = styled.section`
  max-width: 1728px;
  margin: 0 auto;
  padding: 0 144px;
  margin-top: 32px;
  display: flex;
  flex-direction: column;
  gap: 65px;
`;

export const DashboardSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 34px;
`;

export const DashboardTitle = styled.h2`
  font-family: 'Aggro', sans-serif;
  font-size: 28px;
  font-weight: 500;
  color: #ffffff;
  letter-spacing: -0.56px;
`;

export const StatsCard = styled.div`
  background: rgba(0, 110, 73, 0.08);
  border-radius: 30px;
  height: 133px;
  padding: 30px 45px;
  display: flex;
  gap: 143px;
  position: relative;
`;

export const StatItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 11px;
`;

export const StatLabel = styled.div`
  font-family: 'NanumSquareRound', sans-serif;
  font-size: 16px;
  font-weight: 400;
  color: #b3b5bd;
  letter-spacing: -0.32px;
`;

export const StatValue = styled.div<{ $isPositive?: boolean }>`
  display: flex;
  align-items: flex-end;
  gap: 8px;
  font-family: 'NanumSquareRound', sans-serif;
  font-size: 40px;
  font-weight: 800;
  color: ${(props) => (props.$isPositive ? '#07d962' : '#ffffff')};
  letter-spacing: -0.8px;
`;

export const StatUnit = styled.span`
  font-family: 'NanumSquareRound', sans-serif;
  font-size: 18px;
  font-weight: 400;
  color: inherit;
  letter-spacing: -0.36px;
  height: 26px;
`;

export const PortfoliosSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 34px;
`;

export const PortfoliosTitle = styled.h2`
  font-family: 'Aggro', sans-serif;
  font-size: 28px;
  font-weight: 500;
  color: #ffffff;
  letter-spacing: -0.56px;
  padding-left: 45px;
`;

export const TableContainer = styled.div`
  background: ${({ theme }) => theme?.itemBg || '#161a1e'};
  border-radius: 18px;
  border: 1px solid
    ${({ theme }) => theme?.COLORS?.border || 'rgba(255, 255, 255, 0.1)'};
  box-shadow:
    0 6px 24px rgba(0, 0, 0, 0.11),
    0 2px 6px rgba(0, 0, 0, 0.08);
  min-height: 400px;
  position: relative;
  overflow: visible;
  transition: all 0.3s ease;

  &:hover {
    box-shadow:
      0 8px 32px rgba(0, 0, 0, 0.15),
      0 4px 8px rgba(0, 0, 0, 0.1);
  }
`;

export const TableHeader = styled.div`
  display: flex;
  align-items: center;
  height: 50px;
  background: rgba(255, 255, 255, 0.03);
  padding: 0 32px;
  border-bottom: 1px solid
    ${({ theme }) => theme?.COLORS?.border || 'rgba(255, 255, 255, 0.08)'};
`;

export const TableHeaderCell = styled.div<{
  $left?: number;
  $width?: string;
  $align?: 'left' | 'right';
}>`
  flex: ${(props) => props.$width || '1'};
  font-family: 'NanumSquareRound', sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #777986;
  letter-spacing: -0.28px;
  text-align: ${(props) => props.$align || 'left'};
`;

export const TableBody = styled.div`
  padding: 0 32px;
`;

export const TableRow = styled.div`
  display: flex;
  align-items: center;
  height: 56px;
  border-bottom: 1px solid
    ${({ theme }) => theme?.COLORS?.border || 'rgba(255, 255, 255, 0.06)'};
  transition: background 0.2s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.02);
  }

  &:last-child {
    border-bottom: none;
  }
`;

export const TableCell = styled.div<{
  $align?: 'left' | 'right';
  $left?: number;
  $width?: string;
}>`
  flex: ${(props) => props.$width || '1'};
  font-family: 'NanumSquareRound', sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #ffffff;
  letter-spacing: -0.28px;
  text-align: ${(props) => props.$align || 'left'};
`;

export const StatusTag = styled.span<{ $status: number | string }>`
  display: inline-block;
  padding: 4px 12px;
  border-radius: 4px;
  font-family: 'NanumSquareRound', sans-serif;
  font-size: 12px;
  font-weight: 400;
  background: ${(props) =>
    props.$status === 1
      ? 'rgba(7, 217, 147, 0.2)'
      : props.$status === 2
        ? 'rgba(255, 193, 7, 0.2)'
        : 'rgba(255, 77, 79, 0.2)'};
  color: ${(props) =>
    props.$status === 1
      ? '#07d993'
      : props.$status === 2
        ? '#ffc107'
        : '#ff4d4f'};
`;

export const ManageButton = styled.button`
  padding: 8px 16px;
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  color: #ffffff;
  font-family: 'NanumSquareRound', sans-serif;
  font-size: 14px;
  font-weight: 400;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.05);
  }
`;

export const EmptyState = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 500px;
  padding-top: 0;
`;

export const EmptyCharacter = styled.div`
  position: relative;
  width: 322px;
  height: 273px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const SpeechBubble = styled.div`
  position: absolute;
  left: -14px;
  top: 0;
  width: 350px;
  height: 157.812px;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SpeechBubbleImage = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 1;
`;

export const SpeechBubbleText = styled.div`
  position: relative;
  z-index: 2;
  font-family: 'Aggro Medium', sans-serif;
  font-size: 20px;
  font-weight: 500;
  color: #e9e9ed;
  letter-spacing: -0.4px;
  line-height: 32px;
  text-align: center;
  width: 277px;
  white-space: pre-wrap;
  padding-bottom: 20px;
`;

export const CharacterImg = styled.img`
  position: absolute;
  left: 92px;
  top: 95px;
  width: 170px;
  height: 178px;
  object-fit: cover;
  object-position: 50% 50%;
  z-index: 3;
`;

export const PaginationContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-top: 40px;
`;

export const PaginationButton = styled.button`
  width: 30px;
  height: 30px;
  padding: 20px;
  background: transparent;
  border: none;
  border-radius: 6px;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};

  &:hover:not(:disabled) {
    opacity: 0.8;
  }
`;

export const PaginationArrow = styled.img`
  width: 20px;
  height: 20px;
`;

export const PaginationNumber = styled.button<{ $isActive: boolean }>`
  width: 30px;
  height: 30px;
  padding: 20px;
  background: ${(props) => (props.$isActive ? '#07d993' : 'transparent')};
  border: ${(props) => (props.$isActive ? 'none' : '1px solid #353535')};
  border-radius: 6px;
  color: ${(props) => (props.$isActive ? '#0d1117' : '#b3b5bd')};
  font-family: 'NanumSquareRound', sans-serif;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: -0.28px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`;
